module.exports = __webpack_public_path__ + "static/media/ios-airplane.55a73c2b.svg";